import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getCurrentUser, logout } from '../services/api';
import { FaStore, FaBox, FaSignOutAlt, FaBars, FaTimes, FaInfoCircle, FaEnvelope, FaShoppingCart } from 'react-icons/fa';

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [cartCount, setCartCount] = useState(0);
    const user = getCurrentUser();
    const navigate = useNavigate();

    useEffect(() => {
        updateCartCount();
        // Listen for cart updates
        window.addEventListener('cartUpdated', updateCartCount);
        return () => window.removeEventListener('cartUpdated', updateCartCount);
    }, []);

    const updateCartCount = () => {
        const cart = JSON.parse(localStorage.getItem('tfm_cart') || '[]');
        const count = cart.reduce((sum, item) => sum + item.quantity, 0);
        setCartCount(count);
    };

    const handleLogout = () => {
        logout();
        navigate('/');
        window.location.reload();
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <nav className="bg-white shadow-md sticky top-0 z-50">
            <div className="container mx-auto px-4">
                <div className="flex justify-between items-center h-16">
                    {/* Logo */}
                    <Link to="/" className="flex items-center space-x-2 group">
                        <FaStore className="text-purple-600 text-2xl group-hover:scale-110 transition transform" />
                        <span className="text-xl font-bold text-gray-800">TFM Toys</span>
                    </Link>
                    
                    {/* Desktop Menu */}
                    <div className="hidden md:flex items-center space-x-6">
                        <Link to="/" className="text-gray-700 hover:text-purple-600 transition">Home</Link>
                        <Link to="/products" className="text-gray-700 hover:text-purple-600 transition">Products</Link>
                        <Link to="/about" className="text-gray-700 hover:text-purple-600 transition">About</Link>
                        <Link to="/contact" className="text-gray-700 hover:text-purple-600 transition">Contact</Link>
                        
                        {/* Cart Icon */}
                        <Link to="/cart" className="text-gray-700 hover:text-purple-600 transition relative">
                            <FaShoppingCart className="text-xl" />
                            {cartCount > 0 && (
                                <span className="absolute -top-2 -right-3 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                                    {cartCount}
                                </span>
                            )}
                        </Link>
                        
                        {user && user.role === 'admin' && (
                            <>
                                <Link to="/admin" className="text-gray-700 hover:text-purple-600 transition">Dashboard</Link>
                                <Link to="/admin/products" className="text-gray-700 hover:text-purple-600 transition">Manage Products</Link>
                            </>
                        )}
                    
                    </div>
                    
                    {/* Mobile Menu Button */}
                    <button onClick={toggleMenu} className="md:hidden text-gray-700 focus:outline-none">
                        {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
                    </button>
                </div>
                
                {/* Mobile Menu */}
                {isMenuOpen && (
                    <div className="md:hidden py-4 border-t animate-slide-down">
                        <div className="flex flex-col space-y-3">
                            <Link to="/" onClick={toggleMenu} className="text-gray-700 hover:text-purple-600 transition py-2">Home</Link>
                            <Link to="/products" onClick={toggleMenu} className="text-gray-700 hover:text-purple-600 transition py-2">Products</Link>
                            <Link to="/about" onClick={toggleMenu} className="text-gray-700 hover:text-purple-600 transition py-2">About</Link>
                            <Link to="/contact" onClick={toggleMenu} className="text-gray-700 hover:text-purple-600 transition py-2">Contact</Link>
                            
                            {/* Cart Icon for Mobile */}
                            <Link to="/cart" onClick={toggleMenu} className="text-gray-700 hover:text-purple-600 transition py-2 flex items-center gap-2">
                                <FaShoppingCart />
                                Cart {cartCount > 0 && `(${cartCount})`}
                            </Link>
                            
                            {user && user.role === 'admin' && (
                                <>
                                    <Link to="/admin" onClick={toggleMenu} className="text-gray-700 hover:text-purple-600 transition py-2">Dashboard</Link>
                                    <Link to="/admin/products" onClick={toggleMenu} className="text-gray-700 hover:text-purple-600 transition py-2">Manage Products</Link>
                                </>
                            )}
                            
                           
                        </div>
                    </div>
                )}
            </div>
        </nav>
    );
};

export default Navbar;